<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >

 <v-spacer></v-spacer>

      <!-- <v-flex xs12> -->
        <material-card
            :color="app.color">    
            <v-layout row   slot="header">
              <v-flex xs6>
                <span v-if="form.template.reference === undefined" class="title">Formulier Templates</span>
                <span v-if="form.template.reference !== undefined" class="title">{{form.template.name}}</span> <br>
                <span class="body-1">{{user.organisation.name}}</span> 
              </v-flex>
            </v-layout>

            <v-container fluid>
              <v-layout row>
                <v-container fluid>
                <v-tooltip right="" dark="">
                  <template #activator='data'>
                    <v-btn medium text icon color="transparent">
                      <v-icon @click="goBack()" v-on="data.on" :color="app.color">mdi-backspace</v-icon>
                    </v-btn>                  
                  </template>
                  <span>Terug</span>
                </v-tooltip> 

                
                <v-spacer></v-spacer>
                </v-container>
              </v-layout>
            </v-container>

              <v-layout justify-center="" wrap>
                <!-- start of data table -->
                <v-flex sm6 xs12 v-if="form.template.reference === undefined">
                  <v-list>
                    <div v-for="(item, index) in form.templates" :key="index" >
                        
                        <v-list-item
                          @click="getFormTemplate({reference:item.reference})">
                          
                          <v-list-item-content>
                        <v-list-item-title>
                          <v-icon>mdi-format-page-break</v-icon> {{form.templates[index].name}}
                        </v-list-item-title>
                        </v-list-item-content>
                        
                        </v-list-item>

                      <v-divider></v-divider>
                    </div>
                    <v-list-item class="mt-4">
                      <v-btn block="" rounded :color="app.color" @click="activateNewFormType()">
                        Nieuw formulier type
                      </v-btn>
                    </v-list-item>                    
                  </v-list>
                </v-flex>
                  <!-- start of fields -->
                  
                <v-flex xs12 sm7 v-if="form.templates.length > 0 && form.template.reference !== undefined">
                  <v-form v-model="valid" >
                  <v-container fluid class="pa-1 form-item" v-for="(section, index) in form.template.fields" :key="index">

                      <v-flex xs12>
                        
                        <v-layout row>
                          <v-flex xs5>
                            <v-select
                              dense
                              label="Resultaat opslaan in:"
                              :items="resultTypes"
                              v-model="form.template.fields[index].level"
                              @change="form.template.fields.field = ''"                             
                            >                           
                            </v-select>
                          </v-flex>
                          <v-flex xs5>
                            <v-select
                              dense
                              label="Veld"
                              v-model="form.template.fields[index].field"
                              :items="getField('object')"     
                              item-text="name" 
                              item-value="field"                       
                            >
                            </v-select>
                          </v-flex>
                          <v-flex xs2>
                            <v-btn icon x-small>  
                              <v-icon color="error" dark @click="deleteSection(index)">mdi-minus</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>                        
                                               
                        <v-layout row>
                          <v-flex xs5>
                            <v-select 
                              v-model="form.template.fields[index].type"
                              label="Type" :items="selectables" dense
                              required=""
                              :rules="rules"                              
                              hide-details=""></v-select>
                          </v-flex>
                          
                          <v-flex xs5>
                            <v-checkbox
                              v-model="form.template.fields[index].required"
                              label="Verplicht veld"
                              hide-details=""
                              >
                            </v-checkbox>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs12>
                            <v-text-field 
                            v-model="form.template.fields[index].question"
                            label="Vraag in formulier"
                            required=""
                            :rules="rules"                            
                            hide-details=""></v-text-field>
                          </v-flex>

                        </v-layout>

                        <v-layout row v-if="form.template.fields[index].type == 'select'">
                          <v-flex xs8>
                            <v-text-field 
                              append-outer-icon="mdi-plus"
                              @click:append-outer="storeArray(index)"
                              v-model="option"
                              hide-details=""
                              >
                            </v-text-field>
                            <span>{{form.template.fields[index].options}}</span>
                          </v-flex>
                        </v-layout>

                      </v-flex>

                  </v-container>
                </v-form>
                  <v-container>
                    <v-layout justify-center="">
                      
                        <v-btn icon rounded dark color="success" @click="addSection()">
                          <v-icon dark>mdi-plus</v-icon>
                        </v-btn>
                      
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12 sm4 v-if="form.templates.length > 0 && form.template.reference !== undefined" >
                  <v-container fluid class="pa-1" >
                  <v-autocomplete 
                    dense
                    label="Object"
                    v-model="form.template.object"
                    :items="types"
                    item-text="description"
                    item-value="reference"
                    prepend-icon="mdi-file-outline"
                    hide-selected
                    @change="getFormObject(form.template.object)"
                  >
                  </v-autocomplete>

                  <!-- <v-autocomplete 
                    disabled
                    dense
                    label="Contract type"
                    v-model="form.template"
                    :items="settings.templates"
                    item-text="name"
                    item-value="reference"
                    prepend-icon="mdi-file-outline"
                    hide-selected
                    @change="change()"
                  >
                  </v-autocomplete>                     -->


                    <v-text-field 
                    label="Formulier naam"
                    :rules="rules"
                    v-model="form.template.name"
                    required>

                    </v-text-field>
                    <v-textarea
                    label="Formulier omschrijving"
                    v-model="form.template.description">

                    </v-textarea>

                  </v-container>
                  
                  <v-layout style="min-height:78px;" justify-center="">
                    <v-flex xs10>
                      <v-btn :disabled="!valid" block rounded dark color="success" @click="storeForm()">
                        formulier template opslaan
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>         
                <!-- <v-flex xs10 v-if="form.templates.length == 0 || form.template.reference == undefined">
                  <v-container>
                  <v-layout justify-center="">
                    <span>Geen template Formulier geselecteerd</span>
                  </v-layout>
                  </v-container>
                </v-flex>       -->
              </v-layout>
              
              <dialog-new-form></dialog-new-form>

        </material-card>
        </v-flex>
   
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    valid: false,
    rules: [v => !!v || "Verplicht veld"],
    option: "",
    array: [],
    active: null,
    tab: null,
    hasChange: false,
    hasChangeType: false,
    selected: [],
    resultTypes: ["object"],
    objectHeaders: [
      { text: "Formulier", value: "description", sortable: false }
    ],
    selectables: ["text", "textarea", "switch", "select"]
  }),
  computed: {
    ...mapState([
      "app",
      "settings",
      "type",
      "types",
      "form.template",
      "form",
      "objects",
      "user"
    ]),
    ...mapGetters(["orderFields"]),
    formObject() {
      return this.$store.state.form.template.object;
    }
  },
  methods: {
    ...mapActions(["getFormTemplate", "storeForm"]),
    activateNewFormType() {
      this.$store.state.form.show = true;
    },
    goBack() {
      if (this.form.template.reference === undefined) {
        this.$router.push("/formulieren");
      } else {
        this.form.template.reference = undefined;
      }
    },
    getField(level) {
      if (level == "contract") {
        return [];
      } else if (level == "object") {
        return this.$store.state.settings.object.fields;
      }
    },
    getFormObject(ref) {
      this.$store.dispatch("getFormObject", { reference: ref });
    },
    getFieldItems(index) {
      var obj = this.$store.state.form.template.fields[index];
      if (
        obj.level == "object" &&
        (obj.object != "" || obj.object != undefined)
      ) {
      }
    },
    storeArray(index) {
      if (this.$store.state.form.template.fields[index].options == undefined) {
        this.$store.state.form.template.fields[index].options = [];
      }

      if (this.option != "") {
        this.$store.state.form.template.fields[index].options.push(this.option);
        this.option = "";
      }
    },
    addSection() {
      this.$store.state.form.template.fields.push({
        options: [],
        question: "",
        type: ""
      });
      this.hasChangeType = true;
    },
    deleteSection(index) {
      this.$store.state.form.template.fields.splice(index, 1);
    }
  },

  created() {
    this.$store.dispatch("checkAuth");
    this.$store.dispatch("settingsGetTemplates");
    this.form.template.reference = undefined;

    // this.$store.dispatch("settingsGetObjects");
  }
};
</script>

<style scoped>
.selectorRow {
  background-color: rgb(116, 136, 116) !important;
}

.form-item {
  background-color: rgb(240, 240, 240);
  /* margin: 10px; */
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  min-height: 75px;
}
</style>

